import React from 'react';
interface ProgressBarProps {
  current: number;
  total: number;
  label?: string;
}
export function ProgressBar({
  current,
  total,
  label
}: ProgressBarProps) {
  const percentage = Math.min(100, Math.max(0, current / total * 100));
  return <div className="w-full max-w-md mx-auto mb-12" data-id="element-156">
      <div className="flex justify-between items-center mb-3 text-xs font-bold text-[#6B7280] uppercase tracking-widest" data-id="element-157">
        <span data-id="element-158">{label || 'Progress'}</span>
        <span className="text-[#E10600]" data-id="element-159">
          {Math.round(percentage)}% COMPLETE
        </span>
      </div>
      <div className="h-1.5 w-full bg-[#1a1f2b] rounded-sm overflow-hidden" data-id="element-160">
        <div className="h-full bg-[#E10600] transition-all duration-500 ease-out shadow-[0_0_10px_rgba(225,6,0,0.5)]" style={{
        width: `${percentage}%`
      }} data-id="element-161" />
      </div>
    </div>;
}